import m from 'mithril'

import texture from './locked-scrap.png'
import LockIcon from './LockIcon.js'
import UnlockedIcon from './UnlockedIcon.js'

export default {
  view: vnode => {
    const text = vnode.attrs.hotspot.text
    const locked = vnode.attrs.hotspot.locked

    return (
      <article
        className={`hotspot-inner hotspot-locked u-hotspot-fade mod-${vnode.attrs.hotspot.id}`}
      >
        {texture && <img src={texture} className="hotspot-locked-texture" />}
        <div className="hotspot-flex-container">
          {locked ? <LockIcon /> : null}
          {text && <p className="hotspot-locked-text">{m.trust(text)}</p>}
        </div>
      </article>
    )
  }
}
